/* Get Arp Entries Columns */
export const GET_ARP_ENTRIES_COLUMNS_REQUEST = 'GET_ARP_ENTRIES_COLUMNS_REQUEST';
export const GET_ARP_ENTRIES_COLUMNS_SUCCESS = 'GET_ARP_ENTRIES_COLUMNS_SUCCESS';
export const GET_ARP_ENTRIES_COLUMNS_FAILURE = 'GET_ARP_ENTRIES_COLUMNS_FAILURE';

/* Get Arp Entries */
export const GET_ARP_ENTRIES_REQUEST = 'GET_ARP_ENTRIES_REQUEST';
export const GET_INITIAL_ARP_ENTRIES_SUCCESS = 'GET_INITIAL_ARP_ENTRIES_SUCCESS';
export const GET_ARP_ENTRIES_SUCCESS = 'GET_ARP_ENTRIES_SUCCESS';
export const GET_ARP_ENTRIES_FAILURE = 'GET_ARP_ENTRIES_FAILURE';

/* Save Search Parameters */
export const SAVE_ARP_ENTRIES_SEARCH_PARAMETERS = 'SAVE_ARP_ENTRIES_SEARCH_PARAMETERS';

/* Select Arp Entries */
export const SELECT_ARP_ENTRIES_SUCCESS = 'SELECT_ARP_ENTRIES_SUCCESS';

export const SELECT_ALL_ARP_ENTRIES_SUCCESS = 'SELECT_ALL_ARP_ENTRIES_SUCCESS';

/* Add / Update Arp Entries Comments */

export const ADD_OR_EDIT_ARP_ENTRIES_COMMENTS_REQUEST = 'ADD_OR_EDIT_ARP_ENTRIES_COMMENTS_REQUEST';
export const ADD_OR_EDIT_ARP_ENTRIES_COMMENTS_SUCCESS = 'ADD_OR_EDIT_ARP_ENTRIES_COMMENTS_SUCCESS';
export const ADD_OR_EDIT_ARP_ENTRIES_COMMENTS_FAILURE = 'ADD_OR_EDIT_ARP_ENTRIES_COMMENTS_FAILURE';
